module.exports = __webpack_public_path__ + "img/logo-dark-tagline.f5bd9f78.svg";